export const decodeData = (data) => {
  const decoded = data.map((obj) => Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [decodeURIComponent(escape(key)), decodeURIComponent(escape(value))]),
  ));
  return decoded;
};
